import ValueSlider from "components/ValueSlider";
import { MarksItem } from "components/ValueSlider/ValueSlider";
import React, { useState } from "react";

function Starter() {
  const handleBtnClick = () => {
    window.open("https://bit.ly/Reqdemo", "_blank");
  };

  return (
    <div className="page-padding price_container_bundles h-fit">
      <div>
        <h4>Starter</h4>
        <h2>
          $1080
          <span className="text-xs">/mo</span>
        </h2>
      </div>
      <div className="my-2">
        <p>• 10 GB Storage & Streaming</p>
        <p>• 1000 SMS & Emails</p>
        <p>• 400 cbee.ai Credits</p>
        <p>• 8 Newsletter Credits</p>
        <p className="item_left_padding">& much more</p>
      </div>
    </div>
  );
}

export default Starter;
